import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import React, { useState } from 'react';
import Modal from '@amzn/meridian/modal';
import Text from '@amzn/meridian/text';
import { InfoIconButton } from 'src/common/buttons/infoIconButton';
import { usePageContext } from 'src/hooks';
export const DealBadgePopover = ({ endTime, locale }) => {
    const [isOpen, setIsOpen] = useState(false);
    const { bundle } = usePageContext();
    const formattedEndDate = new Date(endTime).toLocaleDateString(locale, {
        year: 'numeric',
        month: 'long',
        day: 'numeric',
    });
    return (_jsxs(_Fragment, { children: [_jsx(InfoIconButton, { onClick: () => setIsOpen(true), ariaLabel: bundle.getMessage('dealTermsInfoButton'), dataTestId: "deal-badge-terms-button" }), _jsx(Modal, { open: isOpen, onClose: () => setIsOpen(false), "data-testid": "deal-badge-terms-modal", title: _jsx("span", { "data-testid": "deal-badge-terms-header", children: bundle.formatMessage('dealTermsHeader', { date: formattedEndDate }) }), fullscreenBreakpoint: 0, width: 320, children: _jsx(Text, { type: "b300", "data-testid": "deal-badge-terms-body", children: bundle.getMessage('dealTermsBody') }) })] }));
};
